import { AnnualReportExcelSheetTable } from './annual-report-excel-sheet-table.interface';

export interface AnnualReportExcelSheet {
    tables: AnnualReportExcelSheetTable[];
    name: string;
}
